import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslate } from 'react-redux-multilingual'
import DataTable from '../../../components/DataTable/DataTable'

import * as actions from '../../../store/actions'

import Aux from '../../../hoc/Auxiliary/Auxiliary'
import Card from '../../../components/UI/Card/Card'
import CardBody from '../../../components/UI/Card/Body/Body'
import CardHeader from '../../../components/UI/Card/Header/Header'

import Alert from '../../../components/Alert/Alert'

import FilterModal from '../../../components/FilterModal/FilterModal'

import { clearFilterOptionValues, updateObject } from '../../../helpers/utils'

import ActionBar from '../../../components/ActionBar/ActionBar'

// import Content
import * as moment from 'moment'
import PleaseFilter from '../../../components/PleaseFilter/PleaseFilter'

class UsageLog extends Component {
  state = {
    usageLogData: null,
    filterModalOpen: false,

    filterControls: {
      start_date: {
        label: this.props.translate('startDate'),
        inputType: 'datePickerYMD',
        configs: {
          type: 'text'
        }
      },
      end_date: {
        label: this.props.translate('endDate'),
        inputType: 'datePickerYMD',
        configs: {
          type: 'text'
        }
      },
      action: {
        label: this.props.translate('action'),
        value: 'All',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('action'),
          options: [
            { value: 'Add', label: 'Add' },
            { value: 'Edit', label: 'Edit' },
            { value: 'Delete', label: 'Delete' },
            { value: 'View', label: 'View' }
          ]
        },
        required: true
      }
    },
    updateProps: {
      start_date: null,
      end_date: null,
      action: null
    }
  }

  //   static getDerivedStateFromProps = (props, state) => {
  //     let updatedState = {}
  //     let { updateProps } = state

  //     const updateOptions = (stateId, propsId, attr, withCode) => {
  //       const inputGroups = state.inputGroups
  //       const targetThresholdGroupItem = inputGroups[stateId]
  //       let [attrId, attrCode, attrName, attrPlaceHolder] = attr

  //       updatedState = {
  //         ...updatedState,
  //         inputGroups: {
  //           ...inputGroups,
  //           [stateId]: updateFormOptions(
  //             props[propsId],
  //             targetThresholdGroupItem,
  //             attrId,
  //             attrId,
  //             attrName,
  //             attrPlaceHolder,
  //             null,
  //             null,
  //             withCode ? attrCode : null
  //           )
  //         },
  //         updateProps: { ...updateProps, [propsId]: props[propsId] }
  //       }
  //     }

  //     return updatedState
  //   }

  // Close
  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  // Open
  openFilterModal = () => {
    let default_data_filter = this.state.filterControls
    default_data_filter.start_date.value = new Date()
    default_data_filter.end_date.value = new Date()
    default_data_filter.action.value = 'All'

    this.setState({
      filterModalOpen: true,
      filterControls: default_data_filter
    })
  }

  // Clear Filter
  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    const updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    let param = {
      start_date: moment(this.state.filterControls.start_date.value).format('YYYY-MM-DD'),
      end_date: moment(this.state.filterControls.end_date.value).format('YYYY-MM-DD'),
      action: this.state.filterControls.action.value.value
    }
    this.props.fetchUsageLog(param)
    this.closeFilterModal()
  }

  onPageChangeHandler = (event, page) => {
    let param = {
      start_date: moment(this.state.filterControls.start_date.value).format('YYYY-MM-DD'),
      end_date: moment(this.state.filterControls.end_date.value).format('YYYY-MM-DD'),
      action: this.state.filterControls.action.value.value,
      page: page,
      perPage: this.props.pagination.perPage
    }
    this.props.fetchUsageLog(param)
  }

  onPerPageChangeHandler = perPage => {
    let param = {
      start_date: moment(this.state.filterControls.start_date.value).format('YYYY-MM-DD'),
      end_date: moment(this.state.filterControls.end_date.value).format('YYYY-MM-DD'),
      action: this.state.filterControls.action.value.value,
      currentPage: this.props.pagination.currentPage,
      perPage
    }
    this.props.fetchUsageLog(param)
  }

  UsageLogTable = [
    { field: 'usage_datetime', title: this.props.translate('usageDateTime'), type: 'string' },
    { field: 'user_name', title: this.props.translate('userName'), type: 'string' },
    { field: 'full_name', title: this.props.translate('fullName'), type: 'string' },
    { field: 'emp_code', title: this.props.translate('empCode'), type: 'string' },
    { field: 'page_name', title: this.props.translate('pageName'), type: 'string' },
    { field: 'action', title: this.props.translate('action'), type: 'string' },
    { field: 'action_id', title: this.props.translate('dataId'), type: 'string' }
  ]

  render() {
    let content = <PleaseFilter />
    if (this.props.usageLogData !== null) {
      content = (
        <DataTable
          tableTitle={this.props.translate('tableUsageLog')}
          data={this.props.usageLogData}
          structure={this.UsageLogTable}
          loading={this.props.loading}
          pagination={this.props.pagination}
          pageChange={this.onPageChangeHandler}
          perPageChange={this.onPerPageChangeHandler}
          rowActions={this.rowActions}
        />
      )
    }

    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, event) => this.filterChangedHandler(itemKey, event)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Card>
          <CardHeader>
            <ActionBar filtering={this.openFilterModal} show={['filter']} />
          </CardHeader>
          <CardBody>{content}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    usageLogData: state.usageLog.usageLogData,
    pagination: state.usageLog.pagination
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUsageLog: filterOptions => {
      dispatch(actions.fetchUsageLog(filterOptions))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(UsageLog))
